import withPageTitle from "../../../routes/containers/withPageTitle"
import Attribution from "../components/Attribution"

export default withPageTitle("Third-Party Resources")(Attribution)
